angular.module('leanlaw').directive("radioList", ["$timeout", function ($timeout) {
  return {
    restrict: "E",
    require: "ngModel",
    // replace: true,
    template: require("./views/radioList.html"),
    scope: {
      ngModel: "=",
      options: "=",
      ngChange: "=?"
    },
    link: function ($scope, element, attrs) {
      $scope.selectOption = function (option) {
        $scope.ngModel = option.value;
        if ($scope.ngChange) $scope.ngChange(option);
      };
      $scope.isSelected = function (option) {
        return $scope.ngModel == option.value;
      };
    }
  };
}]);